import 'immer';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import type {
  PurchaseOrder,
  PurchaseOrderSearchOutput,
  PurchaseOrderSearchInput,
} from '@repo/api-contract';
import ApiClient from '../../util/api-client';
type SearchBy = PurchaseOrderSearchInput['searchBy'];

export interface PurchaseOrderBrowseState {
  searchInput: string;
  results?: PurchaseOrderSearchOutput;
  searchBy: SearchBy;
  loading: boolean;
  activeSelection?: PurchaseOrder;
}

// Initialize state
const initialState: PurchaseOrderBrowseState = {
  searchInput: '',
  results: undefined,
  searchBy: 'orderCode',
  loading: false,
  activeSelection: undefined,
};

export const purchaseOrderBrowseSlice = createSlice({
  name: 'purchaseOrderBrowse',
  initialState,
  reducers: {
    setSearchInput: (state, action: PayloadAction<string>) => ({
      ...state,
      searchInput: action.payload,
    }),
    setSearchBy: (state, action: PayloadAction<SearchBy>) => ({
      ...state,
      searchBy: action.payload,
    }),
    setResults: (
      state,
      action: PayloadAction<PurchaseOrderSearchOutput | undefined>,
    ) => ({
      ...state,
      results: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      loading: action.payload,
    }),
    setActiveSelection: (state, action: PayloadAction<PurchaseOrder>) => ({
      ...state,
      activeSelection: action.payload,
    }),
  },
});

export const {
  setSearchInput,
  setSearchBy,
  setResults,
  setLoading,
  setActiveSelection,
} = purchaseOrderBrowseSlice.actions;
export default purchaseOrderBrowseSlice.reducer;

// Thunks
export const searchPurchaseOrders =
  (searchInput: PurchaseOrderSearchInput) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const results = await ApiClient.searchPurchaseOrders.query(searchInput);
      dispatch(setResults(results));
    } catch (error: unknown) {
      dispatch(setResults(undefined));
    } finally {
      dispatch(setLoading(false));
    }
  };
